import { render, staticRenderFns } from "./dialogRight.vue?vue&type=template&id=4dbc9bfa&scoped=true&"
import script from "./dialogRight.vue?vue&type=script&lang=js&"
export * from "./dialogRight.vue?vue&type=script&lang=js&"
import style0 from "./dialogRight.vue?vue&type=style&index=0&id=4dbc9bfa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbc9bfa",
  null
  
)

export default component.exports